import { PropsWithChildren, ReactElement } from 'react';
import { FormControlError } from '../../../core/shared/forms/useForm';
import { KeysMatching, NonEmptyArray } from '../../../utils/types';
import { Select } from '../select/Select';

type SelectFieldProps<
  I extends { [key in K | V | T]: string | number } & Record<
    K | V | T | string,
    string | number | unknown
  >,
  K extends KeysMatching<T, string | number>,
  V extends KeysMatching<T, string | number>,
  T extends KeysMatching<T, string | number>
> = {
  style?: 1;
  label: string;
  value?: I[V];
  options: I[];
  keyProp: K;
  valueProp: V;
  textProp: T;
  errors?: NonEmptyArray<FormControlError>;
  onChange: (value: I[V]) => void;
};

export const SelectField = <
  I extends { [key in K | V | T]: string | number } & Record<
    string,
    string | number | unknown
  >,
  K extends KeysMatching<T, string | number>,
  V extends KeysMatching<T, string | number>,
  T extends KeysMatching<T, string | number>
>({
  style = 1,
  label,
  value,
  keyProp,
  valueProp,
  textProp,
  options,
  errors,
  onChange,
}: PropsWithChildren<SelectFieldProps<I, K, V, T>>): ReactElement | null => {
  return (
    <div className="login__form__field__row">
      <label className="login__form__field__row__label">{label}</label>
      <Select
        style={style}
        value={value}
        keyProp={keyProp}
        valueProp={valueProp}
        textProp={textProp}
        options={options}
        errors={errors}
        onChange={onChange}
      />
      {errors && (
        <p className="assistive_text assistive_text--error">
          {errors.map(({ message }) => message).join(', ')}
        </p>
      )}
    </div>
  );
};
